import * as React from "react"

const CloseButton = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="#707070"
        {...props}
        viewBox={'0 0 16 16'}
    >
        <path
            fill="inherit"
            stroke={'none'}
            d="M14.4 2.88 13.12 1.6 8 6.72 2.88 1.6 1.6 2.88 6.72 8 1.6 13.12l1.28 1.28L8 9.28l5.12 5.12 1.28-1.28L9.28 8l5.12-5.12Z"
        />
    </svg>
)

export default CloseButton
